import PageEventRanksClubs from "pages/ma/event-ranks/clubs";

const seriesRouters = [
  { path: "/event-ranks/:slug/clubs", component: PageEventRanksClubs },
];

export default seriesRouters;
